module.exports = __webpack_public_path__ + "img/default_portrait.133ed70b.png";